import {
  ClaimFormData,
  PostClaimRequestBody,
  ClaimProductInputField,
  ClaimDetailInputField,
  ClaimNonOrderProductInputField
} from "src/types";
import { IdGenerator } from "src/utils";

export class ClaimMapper {
  public static initClaimProductInputField(): ClaimProductInputField {
    return {
      fieldId: IdGenerator.generateUniqueElementId(),
      productId: "",
      productName: "",
      sku: "",
      quantity: 0,
      claimQuantity: "",
      unitPrice: 0
    };
  }

  public static initClaimDetailInputField(issueType: "damage" | "discrepancy" = "damage"): ClaimDetailInputField {
    return {
      fieldId: IdGenerator.generateUniqueElementId(),
      claimType: issueType === "damage" ? "Physical Damage" : "Quantity Shortage",
      urgencyLevel: "Medium",
      detailedDescription: ""
    };
  }

  public static initClaimNonOrderProductInputField(): ClaimNonOrderProductInputField {
    return {
      fieldId: IdGenerator.generateUniqueElementId(),
      productId: "",
      claimQuantity: "",
      extraInfo: ""
    };
  }

  public static initClaimFormData(issueType: "damage" | "discrepancy" = "damage"): ClaimFormData {
    return {
      purchaseOrderId: "",
      issueType,
      products: [],
      claimDetails: [this.initClaimDetailInputField(issueType)],
      warehouseLocation: "",
      claimImages: []
    };
  }

  public static claimRequestBodyFromFormData(claimFormData: ClaimFormData): PostClaimRequestBody {
    const products = claimFormData.products
      .filter((product) => {
        if (product.deleted) return false;
        const qty = product.claimQuantity?.trim();
        if (!qty) return false;
        const parsedQty = parseInt(qty, 10);
        return !isNaN(parsedQty) && parsedQty > 0;
      })
      .map((product) => {
        return {
          productId: product.productId.trim(),
          claimQuantity: parseInt(product.claimQuantity, 10)
        };
      });

    const claimDetails = claimFormData.claimDetails
      .filter((detail) => detail.detailedDescription.trim().length > 0)
      .map((detail) => {
        const mappedDetail: any = {
          claimType: detail.claimType,
          urgencyLevel: detail.urgencyLevel,
          detailedDescription: detail.detailedDescription.trim()
        };

        if (detail.nonOrderProducts && detail.nonOrderProducts.length > 0) {
          const validNonOrderProducts = detail.nonOrderProducts
            .filter((product) => {
              const productId = product.productId?.trim();
              const claimQty = product.claimQuantity?.trim();
              return productId && claimQty && !isNaN(parseInt(claimQty, 10)) && parseInt(claimQty, 10) > 0;
            })
            .map((product) => ({
              productId: product.productId.trim(),
              claimQuantity: parseInt(product.claimQuantity, 10),
              extraInfo: product.extraInfo?.trim() || ""
            }));

          if (validNonOrderProducts.length > 0) {
            mappedDetail.nonOrderProducts = validNonOrderProducts;
          }
        }

        return mappedDetail;
      });

    const requestBody: PostClaimRequestBody = {
      purchaseOrderId: claimFormData.purchaseOrderId.trim(),
      issueType: claimFormData.issueType,
      products,
      claimDetails,
      warehouseLocation: claimFormData.warehouseLocation.trim(),
      hasImages: claimFormData.claimImages.length > 0
    };

    return requestBody;
  }
}
